/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'sort': {
    viewBox: '0 0 24 24',
    data: `<polygon points="7.987 7 11.636 10.644 10.885 11.395 7.987 8.502 5.11 11.397 4.359 10.646 7.987 7" style="fill-rule:evenodd"/><rect x="7.497" y="8" width="1" height="9"/><rect x="14.641" y="9" width="1" height="3" transform="translate(25.641 -4.641) rotate(90)"/><rect x="15.391" y="11.25" width="1" height="4.5" transform="translate(29.391 -2.391) rotate(90)"/><rect x="16.141" y="13.5" width="1" height="6" transform="translate(33.141 -0.141) rotate(90)"/>`
  }
})
